import request from '@/utils/request'
import { method } from '@/utils/constant'

const { POST, GET } = method

export default {
  // 会员统计看板数据
  async getStatistics() {
    return request({ method: GET, url: `/admin/approval/statistics` })
  },

  async getMemberMapData() {
    return request({ method: GET, url: `/admin/statistics/map` })
  },
  async getMemberOtherData(params) {
    return request({ method: POST, url: `/admin/statistics/histogram`, params })
  },
  async getServiceTypes() {
    return request({ method: GET, url: `/admin/statistics/getAssociation` })
  },

  // 入会统计看板数据
  async getMembershipData(params) {
    return request({ method: POST, url: `/admin/approval/joinStatistics`, params })
  },

  getMembershipMapData() {
    return request({ method: POST, url: `/admin/statistics/joinMap`, params: {} })
  },
  getMembershipOtherData(params) {
    return request({ method: POST, url: `/admin/statistics/joinMonth`, params })
  },

  // 缴费统计看板数据
  async getPaymentData(params) {
    return request({ method: POST, url: `/admin/approval/payStatistics`, params })
  },

  getPaymentTotalData() {
    return request({ method: POST, url: `/admin/statistics/payStatistics`, params: {} })
  },
  getPaymentChartData(params) {
    return request({ method: POST, url: `/admin/statistics/payHistogram`, params })
  },
  getMemberTypes() {
    return request({ method: POST, url: `/admin/statistics/payStatistics` })
  },
}
